<!-- Select Addons Sidebar -->
<p-drawer [closeOnEscape]="false" [visible]="showAddonsSidebar()" [showCloseIcon]="false" position="left" [blockScroll]="false" [dismissible]="false"
  styleClass="w-12 md:w-9 xl:w-7 p-0 no-header" [appendTo]="'body'" [autoZIndex]="true" (onHide)="closeSidebar(true)">
  <ng-template #headless>
    <!-- Header -->
    <div class="border-bottom-1 border-300 relative flex align-items-center sticky left-0 top-0 w-full surface-0 z-5">
      <div (click)="closeSidebar(true)" class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center"><i class="fa fa-times text-600 text-xl"></i></div>
      <h4 class="mb-0 ml-3 text-base font-bold">{{'BILLING_ADDONS.SELECT_ADDONS' | translate }}</h4>
    </div>
    <!-- Header -->

    <form [formGroup]="planAddonsForm">
      <!-- Content Wrapper -->
      <div class="p-sidebar-content__wrapper">
        <!-- Search -->
        @if (!showSkeleton) {
          <div class="p-inputgroup border-bottom-1 border-300 py-2 px-3">
            <span class="p-inputgroup-addon">
              <i class="fa fa-search"></i>
            </span>
            <input pInputText #searchProduct [placeholder]="'BILLING_ADDONS.SEARCH_PLACE' | translate" class="text-sm" />
          </div>
        }
        <!-- Search -->
        <!-- Search With Skeleton -->
        @if (showSkeleton) {
          <div class="py-2 px-3">
            <p-skeleton width="100%" height="2rem" />
          </div>
        }
        <!-- Search With Skeleton -->

        <!-- Content -->
        <div class="surface-100 p-3">
          <!-- Filter By -->
          @if (!showSkeleton) {
            <div class="border-bottom-1 border-300 pb-1 flex align-items-center text-sm">
              <span class="mr-2">{{'BILLING_ADDONS.FILTER_BY' | translate }}</span>
              <p-select
                [options]="addonCategories"
                optionLabel="name"
                filterBy="name"
                styleClass="w-full text-sm text-primary border-none p-0 surface-100 flex align-items-center"
                [placeholder]="'BILLING_ADDONS.ADDON_CATEGORY' | translate"
                dropdownIcon="fa fa-caret-down text-primary mr-3"
                formControlName="selected_category"
                (onChange)="FilterByCategory()"
                >
                <ng-template pTemplate="selectedItem">
                  @if (SelectedCategoryFormControl.value) {
                    <strong class="text-primary text-sm">{{SelectedCategoryFormControl.value.name}}</strong>
                  }
                </ng-template>
                <ng-template let-addonCategory pTemplate="item">
                  <div class="text-sm">{{addonCategory.name}}</div>
                </ng-template>
              </p-select>
              <p-select
                [options]="serviceTypeCollection"
                optionLabel="name"
                filterBy="name"
                styleClass="w-full text-sm text-primary border-none p-0 surface-100 flex align-items-center"
                [placeholder]="'BILLING_ADDONS.ADDON_SERVICE' | translate"
                dropdownIcon="fa fa-caret-down text-primary"
                formControlName="selected_serviuce_category"
                (onChange)="FilterByServiceCategory()"
                >
                <ng-template pTemplate="selectedItem">
                  @if (SelectedServiceCategoryFormControl.value) {
                    <strong class="text-primary text-sm">{{SelectedServiceCategoryFormControl.value.name}}</strong>
                  }
                </ng-template>
                <ng-template let-addonService pTemplate="item">
                  <div class="text-sm">{{addonService.name}}</div>
                </ng-template>
              </p-select>
            </div>
          }
          <!-- Filter By -->

          <!-- Filter By with Skeleton -->
          @if (showSkeleton) {
            <div class="border-bottom-1 border-300 pb-1 flex align-items-center text-sm">
              <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2 w-2rem md:w-6rem" />
              <p-skeleton width="10rem" height="2rem" styleClass="mr-3 w-8rem md:w-10rem" />
              <p-skeleton width="10rem" height="2rem" styleClass="w-8rem md:w-10rem" />
            </div>
          }
          <!-- Filter By with Skeleton -->

          <!-- Cards without Skeleton -->
          @if (!showSkeleton) {
            <div>
              <!-- Product List -->
              @if (isRecurringSubscriptions) {
                <div class="my-4">
                  @if ((recurringGroupedData | keyvalue).length > 0) {
                    <strong class="border-1 border-primary bg-blue-50 text-primary line-height-1 text-xs text-center p-2 border-round mb-3 inline-block">{{'BILLING_ADDONS.RECURRING' | translate }}</strong>
                  }
                  @for (service of recurringGroupedData | keyvalue; track service.key) {
                    @if (getServiceCategoryName(service.key); as service) {
                      <h6 class="mb-3 text-sm">{{ service.name_primary_language || service.name_secondary_language}}</h6>
                    }
                    <ul class="pl-0 list-none grid mb-3">
                      @for (addon of service.value | addonFilter : { filter: searchProduct?.value }; track addon.id) {
                        <li class="col-12 md:col-6">
                          <div class="surface-0 border-round border-1 border-300 shadow-2 hover:shadow-7 cursor-pointer"
                            [ngClass]="planAddonsForm.get('selectedAddon_'+addon.id).value ? 'border-primary' : 'border-300' ">
                            <div class="flex justify-content-between p-3">
                              <h4 class="mb-0 mr-2 text-sm">{{addon.service_name_primary_language}}</h4>
                              <div class="flex align-items-center justify-content-end">
                                <div class="text-right mr-3">
                                  <h3 class="text-lg mb-0">{{ addon.base_cost_in_minor_currency | currencyformat }}</h3>
                                  <p class="mb-0 text-xxs text-600">{{'BILLING_ADDONS.PRICE_INCLUSIVE_TAX' | translate}}</p>
                                </div>
                                <p-checkbox checkboxIcon="fa fa-check" [formControlName]="'selectedAddon_'+addon.id"
                                (onChange)="setRequired($event,addon.id)" checkboxIcon="fa fa-check" [binary]="true" />
                              </div>
                            </div>
                            <div class="surface-400 py-2 px-3 flex align-items-center justify-content-between">
                              <ul class="m-0 p-0 list-none text-xs">
                                <li class="flex align-items-center">
                                  <i class="fa-regular fa-check-square text-600 mr-2"></i>
                                  <strong [innerHTML]="'BILLING_ADDONS.SESSIONS' | translate : {count : addon.sessions}"></strong>
                                </li>
                              </ul>
                            </div>
                            @if (mode() === 'midcycleaddon') {
                              <div class="flex text-xs px-3 py-2">
                                <div class="flex align-items-center" [ngClass]="{ 'ng-invalid ng-dirty': getFormControl('selectedAddonStartFrom_'+addon.id).invalid && getFormControl('selectedAddonStartFrom_'+addon.id).touched }">
                                  <p-radioButton [name]="'selectedAddonStartFrom_'+addon.id" value="Today" [formControlName]="'selectedAddonStartFrom_'+addon.id" [inputId]="'selectedAddonStartFrom_'+addon.id" />
                                  <label for="recurringAddonRadio1" class="ml-2">{{'BILLING_ADDONS.TODAY' | translate}}</label>
                                </div>
                                <div class="flex align-items-center ml-3" [ngClass]="{ 'ng-invalid ng-dirty': getFormControl('selectedAddonStartFrom_'+addon.id).invalid && getFormControl('selectedAddonStartFrom_'+addon.id).touched }">
                                  <p-radioButton [name]="'selectedAddonStartFrom_'+addon.id" value="NextCycle" [formControlName]="'selectedAddonStartFrom_'+addon.id" [inputId]="'selectedAddonStartFrom_'+addon.id" />
                                  <label for="recurringAddonRadio2" class="ml-2">{{'BILLING_ADDONS.NEXT_CYCLE' | translate}}</label>
                                </div>
                              </div>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
              <!-- Product List -->
              <!-- Product List -->
              @if (isNonRecurringSubscriptions) {
                <div class="my-4">
                  @if ((nonRecurringGroupedData | keyvalue).length > 0) {
                    <strong class="border-1 border-primary bg-blue-50 text-primary line-height-1 text-xs text-center p-2 border-round mb-3 inline-block">{{'BILLING_ADDONS.NON_RECURRING' | translate }}</strong>
                  }
                  @for (service of nonRecurringGroupedData | keyvalue; track service.key) {
                    @if (getServiceCategoryName(service.key); as service) {
                      <h6 class="mb-3 text-sm">{{ service.name_primary_language || service.name_secondary_language}}</h6>
                    }
                    <ul class="pl-0 list-none grid mb-3">
                      @for (addon of service.value | addonFilter : { filter: searchProduct?.value }; track addon.id) {
                        <li class="col-12 md:col-6">
                          <div class="surface-0 border-round border-1 border-300 shadow-2 hover:shadow-7 cursor-pointer">
                            <div class="flex justify-content-between p-3">
                              <h4 class="mb-0 mr-2 text-sm">{{addon.service_name_primary_language}}</h4>
                              <div class="flex align-items-center justify-content-end">
                                <div class="text-right mr-3">
                                  <h3 class="text-lg mb-0">{{ addon.base_cost_in_minor_currency | currencyformat }}</h3>
                                  <p class="mb-0 text-xxs text-600">{{'BILLING_ADDONS.PRICE_INCLUSIVE_TAX' | translate}}</p>
                                </div>
                                <p-checkbox checkboxIcon="fa fa-check" [formControlName]="'selectedAddon_'+addon.id" checkboxIcon="fa fa-check" [binary]="true"
                                (onChange)="setRequired($event,addon.id)" />
                              </div>
                            </div>
                            <div class="surface-400 py-2 px-3">
                              <ul class="m-0 p-0 list-none text-xs">
                                <li class="flex align-items-center">
                                  <i class="fa-regular fa-check-square text-600 mr-2"></i>
                                  <strong [innerHTML]="'BILLING_ADDONS.SESSIONS' | translate : {count : addon.sessions}"> </strong>
                                </li>
                              </ul>
                            </div>
                            @if (mode() === 'midcycleaddon') {
                              <div class="px-3 py-2">
                                <label class="font-medium text-700 text-xs block mb-2 uppercase">{{'BILLING_ADDONS.START_DATE' | translate}}</label>
                                <p-datepicker [formControlName]="'selectedAddonStartdate_'+addon.id" [showIcon]="true" icon="fa fa-calendar font-light" dateFormat="M dd,yy" [yearNavigator]="true" yearRange="2023:2030"
                                  placeholder="Select Date" inputStyleClass="text-sm" styleClass="w-full"
                                [ngClass]="{ 'ng-invalid ng-dirty': getFormControl('selectedAddonStartdate_'+addon.id).invalid && getFormControl('selectedAddonStartdate_'+addon.id).touched }" />
                              </div>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
              <!-- Product List -->
            </div>
          }
          <!-- Cards without Skeleton -->

          <!-- Cards with Skeleton -->
          @if (showSkeleton) {
            <div>
              <!-- Product List -->
              <div class="my-4">
                <p-skeleton width="6rem" height="1.875rem" styleClass="mb-3" />
                <p-skeleton width="10rem" height="1.35rem" styleClass="mb-3" />
                <ul class="pl-0 list-none grid mb-3">
                  @for (skeleton of [1,2,3]; track skeleton) {
                    <li class="col-12 md:col-6 lg:col-4">
                      <div class="surface-0 border-round border-1 border-300 shadow-2 cursor-pointer">
                        <div class="flex justify-content-between p-3">
                          <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
                          <div>
                            <p-skeleton width="6rem" height="1.35rem" styleClass="mb-1" />
                            <p-skeleton width="100%" height="1.35rem" />
                          </div>
                        </div>
                        <div class="surface-400 py-2 px-3 flex align-items-center justify-content-between">
                          <ul class="m-0 p-0 list-none text-xs">
                            <li class="flex align-items-center">
                              <p-skeleton width="1rem" height="1rem" styleClass="mr-1" />
                              <p-skeleton width="6rem" height="1.35rem" />
                            </li>
                          </ul>
                          <p-skeleton width="1rem" height="1rem" />
                        </div>
                      </div>
                    </li>
                  }
                </ul>
                <p-skeleton width="10rem" height="1.35rem" styleClass="mb-3" />
                <ul class="pl-0 list-none grid mb-3">
                  @for (skeleton of [1,2,3]; track skeleton) {
                    <li class="col-12 md:col-6 lg:col-4">
                      <div class="surface-0 border-round border-1 border-300 shadow-2 cursor-pointer">
                        <div class="flex justify-content-between p-3">
                          <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
                          <div>
                            <p-skeleton width="6rem" height="1.35rem" styleClass="mb-1" />
                            <p-skeleton width="100%" height="1.35rem" />
                          </div>
                        </div>
                        <div class="surface-400 py-2 px-3 flex align-items-center justify-content-between">
                          <ul class="m-0 p-0 list-none text-xs">
                            <li class="flex align-items-center">
                              <p-skeleton width="1rem" height="1rem" styleClass="mr-1" />
                              <p-skeleton width="6rem" height="1.35rem" />
                            </li>
                          </ul>
                          <p-skeleton width="1rem" height="1rem" />
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </div>
              <!-- Product List -->
              <!-- Product List -->
              <div class="my-4">
                <p-skeleton width="6rem" height="1.875rem" styleClass="mb-3" />
                <p-skeleton width="10rem" height="1.35rem" styleClass="mb-3" />
                <ul class="pl-0 list-none grid mb-3">
                  @for (data of [1,2,3]; track data) {
                    <li class="col-12 md:col-6 lg:col-4">
                      <div class="surface-0 border-round border-1 border-300 shadow-2 cursor-pointer">
                        <div class="flex justify-content-between p-3">
                          <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
                          <div>
                            <p-skeleton width="6rem" height="1.35rem" styleClass="mb-1" />
                            <p-skeleton width="100%" height="1.35rem" />
                          </div>
                        </div>
                        <div class="surface-400 py-2 px-3 flex align-items-center justify-content-between">
                          <ul class="m-0 p-0 list-none text-xs">
                            <li class="flex align-items-center">
                              <p-skeleton width="1rem" height="1rem" styleClass="mr-1" />
                              <p-skeleton width="6rem" height="1.35rem" />
                            </li>
                          </ul>
                          <p-skeleton width="1rem" height="1rem" />
                        </div>
                      </div>
                    </li>
                  }
                </ul>
                <p-skeleton width="10rem" height="1.35rem" styleClass="mb-3" />
                <ul class="pl-0 list-none grid mb-3">
                  @for (data of [1,2,3]; track data) {
                    <li class="col-12 md:col-6 lg:col-4">
                      <div class="surface-0 border-round border-1 border-300 shadow-2 cursor-pointer">
                        <div class="flex justify-content-between p-3">
                          <p-skeleton width="6rem" height="1.35rem" styleClass="mr-2" />
                          <div>
                            <p-skeleton width="6rem" height="1.35rem" styleClass="mb-1" />
                            <p-skeleton width="100%" height="1.35rem" />
                          </div>
                        </div>
                        <div class="surface-400 py-2 px-3 flex align-items-center justify-content-between">
                          <ul class="m-0 p-0 list-none text-xs">
                            <li class="flex align-items-center">
                              <p-skeleton width="1rem" height="1rem" styleClass="mr-1" />
                              <p-skeleton width="6rem" height="1.35rem" />
                            </li>
                          </ul>
                          <p-skeleton width="1rem" height="1rem" />
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </div>
              <!-- Product List -->
            </div>
          }
          <!-- Cards with Skeleton -->
        </div>
        <!-- Content -->
      </div>
      <!-- Content Wrapper -->

      <!-- Sidebar Footer -->
      @if (!showSkeleton) {
        <div class="sticky surface-0 left-0 bottom-0 w-full z-1 flex align-items-center justify-content-between p-3 border-top-1 border-300">
          <p-button (click)="closeSidebar(true)" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="text-sm p-button-text" />
          <p-button (click)="closeSidebar(false)" [label]="'common.BUTTONS.BUTTON-TEXT-SAVE'  | translate" styleClass="text-sm" />
        </div>
      }
      <!-- Sidebar Footer -->

      <!-- Sidebar Footer with Skeleton -->
      @if (showSkeleton) {
        <div class="sticky surface-0 left-0 bottom-0 w-full z-1 flex align-items-center justify-content-between p-3 border-top-1 border-300">
          <p-skeleton width="6rem" height="2rem" />
          <p-skeleton width="6rem" height="2rem" />
        </div>
      }
      <!-- Sidebar Footer with Skeleton -->
    </form>
  </ng-template>
</p-drawer>
<!-- Select Addon Sidebar -->



